module.exports = __webpack_public_path__ + "static/media/img4.3e8fe9ae.jpeg";